import { Injectable } from '@angular/core';
import {SendTask, Message} from '../../class/task';
import { HttpProvider } from '../http/http';

/*
  Generated class for the SendTaskProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SendTaskProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello SendTaskProvider Provider');
    this.choosed_task = new SendTask();
    this.choosed_auto = new SendTask();
    this.keyword_list = [];
    this.task_id = null;
    this.at_switch = 0;
  }

  choosed_task: SendTask;

  choosed_auto: SendTask;

  type:string;

  at_switch: number;

  keyword_list: Array<any>;

  task_id: number;

  message_list:Array<Message>;

  getMaterialList() {
    return this.http.hPost('/get_material_list');
  }

  getTaskList(page, pagesize) {
    let params = {
      page: page,
      pagesize: pagesize,
    };
    return this.http.hPost('/batchsending/get', params);
  }

  createTask(task_id,chatroom_list, client_list,message_list,send_time,announcement = 0) {
    let params = {
      batch_send_task_id:task_id,
      chatroom_list: chatroom_list,
      client_list: client_list,
      message_list: message_list,
      send_time: Math.floor(send_time/1000),
      announcement:announcement
    };
    return this.http.hPost('/batchsending/create', params);
  }

  deleteSendTask(task_id,page,pagesize){
    return this.http.hPost('/batchsending/delete',{batch_send_task_id:task_id,page:page,pagesize:pagesize});
  }

  getSendStatus(){
    return this.http.hPost('/batchsending/get_status');
  }

  resendTask(task_id){
    return this.http.hPost('/batchsending/retry',{batch_send_task_id:task_id});

  }
}



// WEBPACK FOOTER //
// ./src/providers/send-task/send-task.ts